import { applyMultiSort, paginationPath2v, rightsholderBase2v } from '@App/dicts/pathes'
import { PaginationBody } from '@Entities/pagination'
import { CatalogTransferSearchQuery } from '@App/stores/search/models/catalog-transfer-search'

export const setCatalogTransferQueryParams = (
    url: URL,
    searchQuery: CatalogTransferSearchQuery,
    pagination: PaginationBody
) => {
    if (searchQuery.sourcePublisherName) {
        url.searchParams.append('sourcePublisherName', searchQuery.sourcePublisherName)
    }
    if (searchQuery.transferId) {
        url.searchParams.append('transferId', String(searchQuery.transferId))
    }
    if (searchQuery.statuses && searchQuery.statuses.length > 0) {
        url.searchParams.append('statuses', searchQuery.statuses.join(','))
    }
    applyMultiSort(url, pagination)
    return url.toString()
}

export const createCatalogTransfer = (rightsholderId: number) => rightsholderBase2v(rightsholderId, 'transfer')
export const getCatalogTransfer = (rightsholderId: number, transferId: number) =>
    rightsholderBase2v(rightsholderId, `transfer/${transferId}`)
export const getCatalogTransferList = (
    rightsholderId: number,
    searchQuery: CatalogTransferSearchQuery,
    pagination: PaginationBody
) => {
    const url = new URL(rightsholderBase2v(rightsholderId, `transfer/search${paginationPath2v(pagination)}`))
    return setCatalogTransferQueryParams(url, searchQuery, pagination)
}
export const getCatalogTransferReviewList = (
    rightsholderId: number,
    searchQuery: CatalogTransferSearchQuery,
    pagination: PaginationBody
) => {
    const url = new URL(rightsholderBase2v(rightsholderId, `transfer/review${paginationPath2v(pagination)}`))
    return setCatalogTransferQueryParams(url, searchQuery, pagination)
}
export const getSongwriterSubmissionSuggestions = (
    rightsholderId: number,
    statuses: string[],
    pagination?: PaginationBody
) => {
    const url = new URL(
        rightsholderBase2v(rightsholderId, `songwriter-submission-suggestions${paginationPath2v(pagination)}`)
    )
    applyMultiSort(url, pagination)
    statuses.forEach((status) => url.searchParams.append('status', status))
    return url.toString()
}
export const updateSongwriterSubmissionSuggestionStatus = (rightsholderId: number, suggestionId: number) =>
    rightsholderBase2v(rightsholderId, `songwriter-submission-suggestions/${suggestionId}/status`)
export const updateCatalogTransfer = (rightsholderId: number, transferId: number) =>
    rightsholderBase2v(rightsholderId, `transfer/${transferId}`)
export const submitCatalogTransfer = (rightsholderId: number, transferId: number) =>
    rightsholderBase2v(rightsholderId, `transfer/${transferId}/submit`)
export const catalogTransferDecision = (rightsholderId: number, transferId: number) =>
    rightsholderBase2v(rightsholderId, `transfer/${transferId}/decision`)
export const linkCatalogTransferPublisher = (rightsholderId: number, transferId: number) =>
    rightsholderBase2v(rightsholderId, `transfer/${transferId}/link_publisher`)
export const uploadCatalogTransferDocument = (rightsholderId: number, transferId: number) =>
    rightsholderBase2v(rightsholderId, `transfer/${transferId}/upload`)
export const downloadCatalogTransferDocument = (
    rightsholderId: number,
    transferId: number,
    catalogTransferMemberUploadId: number
) => rightsholderBase2v(rightsholderId, `transfer/${transferId}/upload/${catalogTransferMemberUploadId}/download`)
export const importCatalogTransferFile = (rightsholderId: number, transferId: number) =>
    rightsholderBase2v(rightsholderId, `transfer/${transferId}/import`)
export const importCatalogTransferFileStreaming = (rightsholderId: number, transferId: number) =>
    rightsholderBase2v(rightsholderId, `transfer/${transferId}/import/stream`)
export const exportCatalogTransferFile = (rightsholderId: number, transferId: number) =>
    rightsholderBase2v(rightsholderId, `transfer/${transferId}/export`)
